module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2086/plan2-1-2908791d466874c8e6581d167d1a4d52.webp";